const globalColorSwatches = document.getElementById('colorSwatchesData')
  ? JSON.parse(document.getElementById('colorSwatchesData').innerText)
  : null;
const storedProductSkusInSession = JSON.parse(
  sessionStorage.getItem('productSkus')
);
const swatches = document.querySelectorAll('[data-swatches-template]');


/****
 *
 * Helpers
 *
 */

const groupBy = (data, ...keys) => {
  // Takes an array of objects and the property by which they should be grouped.
  // Produces an object of arrays keyed by the specified property values.
  //
  // Provide multiple keys if your data is nested:   groupBy(dogs, 'values', 'emoji')
  //
  // Ex: [{id: 1, group: 'A'}, {id: 2, group: 'B'}, {id: 3, group: 'A'}],   'group'
  //     =>
  //     {A: [{id: 1, group: 'A'}, {id: 3, group: 'A'}], B: [{id: 2, group: 'B'}]}

  // Ex: {values: {color: 'red'}}, ['values', 'color'] => 'red'
  const getGroupFromItem = (item, keys) => {
    return keys.length > 1
      ? getGroupFromItem(item[keys[0]], keys.slice(1))
      : item[keys[0]];
  };

  return data.reduce(
    (results, item) => {
      // Get the first instance of the key by which we're grouping
      var group = getGroupFromItem(item, keys);

      // Ensure that there's an array to hold our results for this group
      results[group] = results[group] || [];

      // Add this item to the appropriate group within results
      results[group].push(item);

      // Return the updated results object to be passed into next reduce call
      return results;
    },
    // Initial value of the results object
    {}
  );
};

//return if the the user, uses touch, or not
function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

/****
 *
 * Helpers End
 *
 */

class ColorSwatches {
  constructor({ globalLinkedProducts, elem }) {
    this.dom = {
      swatches: elem,
    };
    this.options = {};

    this.options = this.getSkuData();
    this.options.id = elem.dataset.swatchesId
      ? Number(elem.dataset.swatchesId)
      : null;
    this.options.type = elem.dataset.swatchesTemplateType
      ? elem.dataset.swatchesTemplateType
      : null;
    this.options.parantTarget = '.product';
    /* If keep is true - keep the swatch Hovered over */
    this.options.keep = false;

    this.options.isTouchDevice = isTouchDevice();

    //if NOT product page, allow this.options.keep = true
    if (!elem.hasAttribute('data-swatches-is-pdp')) {
      if (this.options.isTouchDevice) {
        this.options.keep = true;
      }
    }

    this.options.swatchesLayout = elem.dataset.swatchesLayout;
    this.options.swatchesSize = elem.dataset.swatchesSize;

    switch (this.options.type) {
      case 'product-card':
        this.options.limit = 4;
        break;

      default:
        this.options.limit = 0;
        break;
    }

    this.linkedProducts = this.getLinkedProducts({
      jsonProductData: globalLinkedProducts,
    });

    this.dom.swatches.removeAttribute('data-swatches-template');
    if (this.linkedProducts === undefined || this.linkedProducts.length < 1)
      return this.dom.swatches.remove();

    this.initColorSwatches();
  }

  getSkuData() {
    const productSku = this.dom.swatches.dataset.productSku;
    const productSkuArr = productSku.split('\\');
    /** first item in the array is the sku */
    /** secound item in the array is the colour name */

    /**
     * Gives =>
     * this.options.sku
     * this.options.color
     */



    return { sku: productSkuArr[0], color: productSkuArr[1].toLowerCase() };
  }

  swatch_changeProductCardImage({ item, template }) {
    const productCollectionCardObj = {
      dom: {},
    };
    productCollectionCardObj.dom.main = this.dom.swatches.closest(
      this.options.parantTarget
    );
    productCollectionCardObj.dom.links =
      productCollectionCardObj.dom.main.querySelectorAll('.js-product-link');
    productCollectionCardObj.dom.imageContainer =
      productCollectionCardObj.dom.main.querySelector('.js-swatch-images');
    productCollectionCardObj.dom.productImage =
      productCollectionCardObj.dom.imageContainer.querySelector(
        '.product__img'
      );

    if (!productCollectionCardObj.dom.main) return this.dom.swatches.remove();

    if (
      this.options.isTouchDevice === true ||
      this.options.color !== item.color
    ) {
      const imageElem = document.createElement('img');

      var dataWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512];

      var imgArr = [];
      dataWidths.forEach((dataWidth) => {
        imgArr.push(
          `${Shopify.Image.getSizedImageUrl(
            item.image,
            `${dataWidth}x`
          )} ${dataWidth}w`
        );
      });

      imageElem.setAttribute('srcset', imgArr);
      imageElem.setAttribute('data-widths', dataWidths);
      imageElem.setAttribute('data-sizes', 'auto');
      imageElem.classList.add('swatch-image', 'img-lazyload');
      imageElem.draggable = false;

      productCollectionCardObj.dom.imageContainer.appendChild(imageElem);
      const changeMainImage = (imageElem) => {
        if (!imageElem.hasAttribute('src')) {
          imageElem.classList.add('lazyloaded');
        }
        imageElem.classList.add('is-selected');
        productCollectionCardObj.dom.imageContainer.classList.add(
          'swatch-is-selected'
        );
      };

      const changeLinks = ({ url, links }) => {
        links.forEach((link) => {
          link.href = url;
        });
      };

      template.addEventListener('mouseenter', (event) => {
        if (
          this.options.isTouchDevice === true &&
          this.options.swatchesLayout !== 'thumbnail'
        ) {
          event.preventDefault();

          productCollectionCardObj.dom.imageContainer.classList.remove(
            'swatch-is-selected'
          );
          productCollectionCardObj.dom.imageContainer
            .querySelectorAll('.is-selected')
            .forEach((elem) => {
              elem.classList.remove('is-selected');
            });

          changeLinks({
            url: item.url,
            links: productCollectionCardObj.dom.links,
          });
        }
        changeMainImage(imageElem);
      });

      if (this.options.keep !== true) {
        template.addEventListener('mouseleave', () => {
          imageElem.classList.remove('is-selected');
          productCollectionCardObj.dom.imageContainer.classList.remove(
            'swatch-is-selected'
          );
        });
      }
    }
  }

  getLinkedProducts({ jsonProductData }) {
    if (jsonProductData) {
      return jsonProductData[this.options.sku];
    } else {
      console.warn('no jsonProductData');
      return null;
    }
  }

  initColorSwatches() {
    /** Creating the colour swatches */
    this.createFragments();
  }

  createFragments() {
    const fragment = new DocumentFragment();
    const itemElement = this.dom.swatches.querySelector(
      '.js-color-Swatches__item'
    );
    const itemListElement = this.dom.swatches.querySelector(
      '.js-color-Swatches__list'
    );
    const currentColorObj = {};
    currentColorObj.element = this.dom.swatches.querySelector(
      '[data-color-swatches-current-color]'
    );
    currentColorObj.text =
      currentColorObj.element?.dataset?.colorSwatchesCurrentColor;
    let linkedProductsArray = this.linkedProducts;

    // if (this.options.type !== 'product-card') {
    //   console.log(`linkedProductsArray: `, linkedProductsArray);
    // }

    if (this.options.type === 'product-card') {
      /**
       * Rearrange array so the current product is first
       */
      const currentItemIndex = this.linkedProducts.findIndex((element) => {
        return element.color.toLowerCase() === this.options.color.toLowerCase();;
      });

      const currentItem = linkedProductsArray[currentItemIndex];

      //If the current product is not first, put it first in the array
      if (currentItem && currentItemIndex > 0) {
        linkedProductsArray.splice(currentItemIndex, 1);
        linkedProductsArray.unshift(currentItem);
      }
    }

    if (linkedProductsArray.length) {
      if (this.options.limit > 0) {
        linkedProductsArray = linkedProductsArray.slice(
          0,
          Number(this.options.limit)
        );
      }

      linkedProductsArray.forEach((item) => {
        /**Cloning node and creating template for swatches to manipulate */
        const template = itemElement.cloneNode(true);

        item.color = item.color.toLowerCase();

        this.createSwatches({
          item: item,
          template: template,
          itemListElement: itemListElement,
          currentColorObj: currentColorObj,
        });

        fragment.appendChild(template);
      });

      /**
       * Adding a plus sign, if the amount of variants is more than the limit
       */
      if (
        this.options.limit !== 0 &&
        this.linkedProducts.length > this.options.limit
      ) {
        // const plusIconContainer = itemElement.cloneNode(true);
        // plusIconContainer.innerHTML = '';
        // const plusIcon = document.createElement('div');
        // plusIconContainer.classList.add('plus-icon__container');
        // plusIcon.classList.add('plus-icon');
        // const svg = '<svg version="1.1" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><path d="M61,30.3H33.8V3c0-1-0.8-1.8-1.8-1.8S30.3,2,30.3,3v27.3H3c-1,0-1.8,0.8-1.8,1.8S2,33.8,3,33.8h27.3V61c0,1,0.8,1.8,1.8,1.8  s1.8-0.8,1.8-1.8V33.8H61c1,0,1.8-0.8,1.8-1.8S62,30.3,61,30.3z"/></svg>';
        // plusIcon.innerHTML = svg;
        // plusIconContainer.appendChild(plusIcon);
        // fragment.appendChild(plusIconContainer);

        const plusIconContainer = itemElement.cloneNode(true);
        plusIconContainer.innerHTML = '';
        // const plusIcon = document.createElement('div');
        // plusIcon.classList.add('plus-icon');
        plusIconContainer.classList.add('plus-icon__container');
        const restNumber = document.createElement('span');
        restNumber.innerText = `+ ${this.linkedProducts.length - this.options.limit
          }`;

        // plusIconContainer.appendChild(plusIcon);
        plusIconContainer.appendChild(restNumber);

        fragment.appendChild(plusIconContainer);
      }

      /**Removing placeholders and adding corrct swatches */
      itemListElement.innerHTML = '';
      itemListElement.appendChild(fragment);
    } else {
      itemListElement.innerHTML = '';
    }
  }

  productCollectionCard_swatImages({
    item,
    template,
    productCollectionCardObj,
  }) {
    if (productCollectionCardObj && this.options.color !== item.color) {
      // if (!productCollectionCardObj.dom.swatchImage)  return this.dom.swatches.remove();

      const swatchImageOptions = JSON.parse(
        productCollectionCardObj.dom.swatchImage.dataset
          .productCollectionSwatchImageOptions
      );

      // if (!productCollectionCardObj.dom.swatchImage && !swatchImageOptions.width)  return this.dom.swatches.remove();

      if (!productCollectionCardObj.dom.swatchImage.hasChildNodes()) {
        const imageElem = document.createElement('img');
        imageElem.draggable = false;
        const anchorElem = document.createElement('a');
        anchorElem.appendChild(imageElem);

        productCollectionCardObj.dom.swatchImage.appendChild(anchorElem);
      }

      const imageUrl = Shopify.Image.getSizedImageUrl(
        item.image,
        swatchImageOptions.width
      );

      template.addEventListener('mouseenter', () => {
        productCollectionCardObj.dom.swatchImage.style.display = 'block';
        productCollectionCardObj.dom.swatchImage
          .querySelector('a')
          ?.setAttribute('href', item.url);
        productCollectionCardObj.dom.swatchImage
          .querySelector('img')
          ?.setAttribute('src', imageUrl);
      });

      if (this.options.keep !== true) {
        template.addEventListener('mouseleave', () => {
          productCollectionCardObj.dom.swatchImage.style.display = 'none';
        });
      }
    } else if (productCollectionCardObj && this.options.color === item.color) {
      template.addEventListener('mouseenter', () => {
        productCollectionCardObj.dom.swatchImage.style.display = 'none';
      });
    }
  }

  createSwatches({ item, itemListElement, template, currentColorObj }) {
    if (this.options.type === 'product-card') {
      this.swatch_changeProductCardImage({ item, template });
    }

    this.changeColorTitle({ item, itemListElement, template, currentColorObj });

    if (item.colorName) {
      template
        .querySelector('.js-color-swatch__url')
        .setAttribute('title', item.colorName);
      template
        .querySelector('.js-color-swatch__url')
        .setAttribute('data-color-code', item.color);
      template
        .querySelector('.js-color-Swatches__swatch')
        .setAttribute('alt', item.colorName);
    }

    let globalSwatchValue = null;
    let globalSwatchType = null;

    if (item.color == '900L') {

    }
    if (!!globalColorSwatches[item.color]) {
      globalSwatchValue = globalColorSwatches[item.color];
      globalSwatchType =
        globalSwatchValue.charAt(0) === '#' ? 'color' : 'image';
    }

    if (
      this.options.swatchesLayout === 'swatch' &&
      globalSwatchValue &&
      globalSwatchType === 'color'
    ) {
      /**Hex code */

      const colorDiv = document.createElement('div');
      colorDiv.classList.add('swatch-color');
      colorDiv.style.backgroundColor = globalSwatchValue;
      template
        .querySelector('.js-color-Swatches__swatch')
        .appendChild(colorDiv);
      template.querySelector('.js-color-Swatches__swatch img').remove();
    } else {
      const getImage = () => {
        if (this.options.swatchesLayout === 'thumbnail') {
          return item.image;
        } else if (globalSwatchValue && globalSwatchType === 'image') {
          return globalSwatchValue;
        } else {
          return item.image;
        }
      };

      const itemImage = getImage();

      if (itemImage) {
        /***
         * Include this in theme {{ 'option_selection.js' | shopify_asset_url | script_tag }}
         */

        const imageUrl = Shopify.Image.getSizedImageUrl(
          itemImage,
          '100x100_crop_center'
        );

        template
          .querySelector('.js-color-Swatches__swatch img')
          .setAttribute('src', imageUrl);

        /***
         * Preloads image, so it is displayed faster
         */
        new Image().src = imageUrl;
      }
    }
  }

  changeColorTitle({ item, itemListElement, template, currentColorObj }) {
    if (this.options.color === item.color) {
      template.classList.add('is-selected');
    }

    template
      .querySelector('.js-color-swatch__url')
      .setAttribute('href', item.url);

    if (this.options.isTouchDevice && this.options.keep) {
      template.addEventListener('click', (event) => {
        event.preventDefault();
      });
    }

    template.addEventListener('mouseenter', () => {
      if (currentColorObj.element)
        currentColorObj.element.innerText = item.colorName;

      if (this.options.keep === true) {
        itemListElement
          .querySelectorAll('.js-color-Swatches__item')
          .forEach((elem) => {
            elem.classList.remove('is-selected');
          });

        template.classList.add('is-selected');
      }
    });

    if (this.options.keep === false) {
      //If keep = false, then set color title = original color
      template.addEventListener('mouseleave', () => {
        if (currentColorObj.element)
          currentColorObj.element.innerText = currentColorObj?.text;
      });
    }
  }
}

class ColorSwatchesData {
  constructor() {
    this.options = {};
    this.data = {};
    this.init();
  }

  async init() {
    try {
      //await this.getUrlFetchLimit();
      await this.getRequestUrls();
      await this.getProducts();
      await this.saveToSesseion();
    } catch (e) {
      console.error(e);
    }

    initSwatches({ globalLinkedProducts: this.data });
    reInitSwatchesAfterEvent({ globalLinkedProducts: this.data });
  }

  async getUrlFetchLimit() {
    return fetch('/collections/all?view=swatch-data-limit')
      .then((response) => {
        this.options.urlLimit = response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  async getRequestUrls() {
    const maxPages = 50
    return new Promise((resolve) => {
      const requestUrls = [];
      /**Get all available urls */
      if (maxPages > 0) {
        for (let i = 1; i < parseInt(maxPages) + 1; i++) {
          const urlFetch = fetch(
            `/collections/all?view=swatch-data&page=${i}`
          ).then((response) => response.json());
          requestUrls.push(urlFetch);
        }
      } else {
        const urlFetch = fetch(
          `/collections/all?view=swatch-data&page=${1}`
        ).then((response) => response.json());
        requestUrls.push(urlFetch);
      }
      this.options.requestUrls = requestUrls;
      resolve();
    });
  }

  async getProducts() {
    const _this = this;
    return Promise.all(this.options.requestUrls)
      .then((data) => {
        // Log the data to the console
        // You would do something with both sets of data here
        const merged = [].concat.apply([], data);
        _this.data = groupBy(merged, 'sku');
      })
      .catch((e) => {
        // if there's an error, log it
        console.error(e);
      });
  }

  async saveToSesseion() {
    const mySession = window.sessionStorage;
    mySession.setItem('productSkus', JSON.stringify(this.data));
  }
}

const initSwatches = ({ globalLinkedProducts }) => {
  const swatches = document.querySelectorAll('[data-swatches-template]');
  swatches.forEach((swatch) => {
    void new ColorSwatches({
      globalColorSwatches: globalColorSwatches,
      globalLinkedProducts,
      elem: swatch,
    });
  });
};

const reInitSwatchesAfterEvent = ({ globalLinkedProducts }) => {
  document.addEventListener('Clerk-slider:Loaded', () => {
    initSwatches({ globalLinkedProducts });
  });
};

/**
 * Checking if storedProductSkusInSession exist, and is not an empty object
 */
if (
  storedProductSkusInSession &&
  JSON.stringify(storedProductSkusInSession) !== '{}'
) {
  //if swatches data init swatches
  initSwatches({ globalLinkedProducts: storedProductSkusInSession });
  reInitSwatchesAfterEvent({
    globalLinkedProducts: storedProductSkusInSession,
  });
} else {
  //Get swatches data from custom endpoint
  void new ColorSwatchesData();
}
